import 'reflect-metadata';
import { Exclude, Transform, TransformFnParams, Type, plainToClass } from "class-transformer";
import { Dayjs } from 'dayjs';
import { State } from 'country-state-city';
import CUSTOM_IMG from "../assets/images/cab_fuel/custom.jpg";
import LET2_BEV_IMG from "../assets/images/cab_fuel/LET2_BEV.jpeg";
import LNT_BEV_IMG from "../assets/images/cab_fuel/LNT_BEV.jpeg";
import LET2_CNG_IMG from "../assets/images/cab_fuel/LET2_CNG.jpeg";
import LNT_CNG_IMG from "../assets/images/cab_fuel/LNT_CNG.jpeg";
import LET2_DIESEL_IMG from "../assets/images/cab_fuel/LET2_DIESEL.jpeg";
import LET2CC_DIESEL_IMG from "../assets/images/cab_fuel/LET2CC_DIESEL.jpeg";
import LNT_DIESEL_IMG from "../assets/images/cab_fuel/LNT_DIESEL.jpeg";
import { z } from 'zod';

export const AXIOS_CANCEL_MSG = "axios.cancel";

export const DEFAULT_THROTTLE = 1000;

export const MAXIMUM_FILENAME_LENGTH = 200;

export const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export enum CategoryTags {
  Hidden = "Hidden",
  LayoutReview = "LayoutReview",
  Major = "Major",
  DisableAutoselect = "DisableAutoselect",
}

export enum CustomerTags {
  NationalAccount = "NationalAccount"
}

export enum TruckTags {
  FgiSold = "FgiSold",
  Fgi = "Fgi",
}

export enum AssemblyTags {
  NoOption = "NoOption",
  Obsolete = "Obsolete",
  StrategicPrice = "StrategicPrice",
  PricePendingSupplierQuote = "PricePendingSupplierQuote",
  RequiresUserInput = "RequiresUserInput",
}

export enum FgiStatus {
  Yard = "Yard",
  Shipped = "Shipped",
  Stuck = "Stuck",
  BillAndHold = "BillAndHold",
}

export enum SalesTeamMemberRole {
  Engineer = "Engineer",
  Support = "Support",
  Sales = "Sales",
}


export enum BTS_REPORT_STATUS {
  OPEN = 'OPEN',
  PENDING = 'PENDING',
  DONE = 'DONE',
}


export const BM_BLUE = "rgb(16,178,223)";

export enum NON_DISCOUNTED_TYPE {
  NET = 'NET',
  POST_NET = 'POST_NET',
}
export const DEFAULT_METADATA = "DEFAULT";

export const MARKUP_EXTENDED_WARRANTY = 'EXTENDED_WARRANTY';

export enum ProductionLine {
  LINE_1 = "LINE_1",
  LINE_2 = "LINE_2",
  LINE_3 = "LINE_3",
}

export const InputDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
export const ShortTimeFormat = 'YYYY-MM-DD';

export enum UserType {
  QuoteOnly = "quoteOnly",
  Standard = "standard",
  Admin = "admin",
  Management = "management",
}

export const CUSTOM_WORK_LIST = "custom-work-list";
export const ASSEMBLY_COST_LIST = "assembly-cost-list";
export const ASSEMBLY_LIST = "assembly-list";
export const QUOTE_TABLE = "quote-table";
export const ORDER_TABLE = "order-table";
export const TRUCK_REPORT = "truck-report";
export const SALES_ORDER_REPORT = "sales-order-report";
export const APPROVALS_REPORT = "approvals-report";
export const PRICING_REPORT = "pricing-report";

export const PAGINATION_MAX_PAGE_SIZE = 100000;

export const FRAME_SILL_LENGTH = 'FRAME SILL LENGTH';

export const DRAWING_WIDTH = 3300;
export const DRAWING_HEIGHT = 2550;

export const SOURCEWELL_INCENTIVE_FAMILY = "SOURCEWELL";
export const DEFAULT_CATEGORY_ID = 113;

export const CAB_STYLE_CATEGORY_ID_STR = "cab_style";
export const CAB_STYLE_METADATA_NAME = "CAB STYLE";
export const FUEL_TYPE_CATEGORY_ID_STR = "fuel_type";
export const FUEL_TYPE_METADATA_NAME = "Fuel Type";
export const BODY_APPLICATION_CATEGORY_ID_STR = "body_application";
export const FRAME_CATEGORY_ID_STR = "frame";
export const WHEELBASE_CATEGORY_ID_STR = "frame_wheelbase";

export const FOURTEEN_WEEK_DAY = 98;

export const DAYS_IN_WEEK = 7;

export const OrderSubmissionLegalPhrase = 'By checking the box, <b>I acknowledge and agree</b> that I have had the opportunity to review all the specifications set forth in this Purchase Order, ' +
  'that no changes need to be made to the order and that I will accept the units upon delivery.  By signing this Purchase Order, I further <b>agree, acknowledge and understand</b> that with this Purchase Order, ' +
  'I am placing the order for said units as provided herein, Battle Motors is accepting the order as provided herein and that this order once accepted by Battle Motors may not be canceled or altered. ' +
  'I further <b>understand and agree</b> that with the acceptance of this order, payment for these vehicles shall be invoiced and automatically debited on the fifteen (15) day from Ready-to-Ship (RTS) date, via electronic means.'

export const EmailPattern = /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/;

export enum CountryCode {
  US = "US",
  CA = "CA",
}

const territories = ['UM', 'VI', 'MP', 'AS'];
export const US_STATES = State.getStatesOfCountry(CountryCode.US)
  //remove territories
  .filter(s => !(territories.includes(s.isoCode) || s.isoCode.includes("-")))
  .map(state => ({ name: state.name, value: state.isoCode }));
export const CANADA_PROVINCES = State.getStatesOfCountry(CountryCode.CA).map(state => ({ name: state.name, value: state.isoCode }));

export const defaultMaxDiscountPercent = 25.0;
export const dealerEditIceMaximum = 13.0;
export const dealerEditBevMaximum = 0.0;
export const dealerEditCustomChassisMaximum = 0.0;

export enum RevisionApprovalStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  DRAFT = 'DRAFT'
}

export const MISSING_IMAGE = "data:image/png;base64,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";

export const QUOTE_DEFAULTS: QuoteDefaults = {
  percentDiscount: 0.0,
  quantity: 1
}

export enum OPERATION_TYPE {
  CHASSIS = 'CHASSIS',
  CAB = 'CAB',
  BOTH = 'BOTH',
}


export const CabStyles: Record<string, CabStyle> = {
  "LNT": { name: "LNT", description: "LNT", valueText: "LNT Crew Cab" },
  "LET2": { name: "LET2", description: "Raider", valueText: "Standard" },
  "LET2CC": { name: "LET2CC", description: "Raider CC", valueText: "Crew Cab" },
  "CUSTOM": { name: "Custom", description: "Custom", valueText: "Custom" },
};

export const FuelTypes: Record<string, FuelType> = {
  "BEV": { name: "BEV", description: "Electric", valueText: "BEV" },
  "CNG": { name: "CNG", description: "CNG", valueText: "CNG" },
  "DIESEL": { name: "Diesel", description: "Diesel", valueText: "DIESEL" },
};


export const FuelTypeColor: Record<string, string> = {
  BEV: "#40b8e4",
  CNG: "#23C01B",
  DIESEL: "#ed1c24",
};

export const DefaultCabFuelImageLst = [
  {
    fuelType: FuelTypes.BEV,
    cabStyle: CabStyles.LET2,
    imageUri: LET2_BEV_IMG,
  },
  {
    fuelType: FuelTypes.BEV,
    cabStyle: CabStyles.LNT,
    imageUri: LNT_BEV_IMG,
  },
  {
    fuelType: FuelTypes.BEV,
    cabStyle: CabStyles.CUSTOM,
    imageUri: CUSTOM_IMG,
  },
  {
    fuelType: FuelTypes.CNG,
    cabStyle: CabStyles.LET2,
    imageUri: LET2_CNG_IMG,
  },
  {
    fuelType: FuelTypes.CNG,
    cabStyle: CabStyles.LET2CC,
    imageUri: LET2CC_DIESEL_IMG, //recycle image
  },
  {
    fuelType: FuelTypes.CNG,
    cabStyle: CabStyles.LNT,
    imageUri: LNT_CNG_IMG,
  },
  {
    fuelType: FuelTypes.CNG,
    cabStyle: CabStyles.CUSTOM,
    imageUri: CUSTOM_IMG
  },
  {
    fuelType: FuelTypes.DIESEL,
    cabStyle: CabStyles.LET2,
    imageUri: LET2_DIESEL_IMG,
  },
  {
    fuelType: FuelTypes.DIESEL,
    cabStyle: CabStyles.LET2CC,
    imageUri: LET2CC_DIESEL_IMG,
  },
  {
    fuelType: FuelTypes.DIESEL,
    cabStyle: CabStyles.LNT,
    imageUri: LNT_DIESEL_IMG,
  },
  {
    fuelType: FuelTypes.DIESEL,
    cabStyle: CabStyles.CUSTOM,
    imageUri: CUSTOM_IMG
  },
]



export interface FlowAssembly {
  id: number;
  name: string;
}

export type CategoryIdCustomOptionIdMap = Record<number, number[]>
export type CategoryIdAssembliesIdMap = Record<number, number[]>

export interface CategoryIdAssembliesMap {
  [categoryId: string]: Assembly[]
}

export interface AssemblyBase {
  id: number
  bom: string
  bomDescription: string | undefined
  label: string | undefined
  categoryId?: number
}


export interface AssemblyMetadataInfo {
  id:number
  categoryMetadataId:number
  name:string
  valueText:string
  valueBool:boolean
  valueNumeric:number
  valueDecimal:number
}
export interface AssemblyWithMetadata extends AssemblyBase {
  category: CategoryInfo
  metadata: AssemblyMetadataInfo[]
  obsoletedAt: Date | undefined;
  thumbnailImageUrl?: string;
  notes?: string
}

export interface AssemblyInfo extends AssemblyBase {
  standardMaterialCost: number | undefined
  laborCost: number | undefined
  laborHours: number | undefined

  epicorStandardMaterialCost: number | undefined
  epicorStandardMaterialCostDiff: number | undefined
  epicorStandardMaterialCostPercentDiff: number | undefined
  epicorSubcontractCost: number | undefined

  categoryName: string
  configuratorSection: string
  category?: CategoryInfo
  createdAt: Date
  dependencyRules: string
  imported: boolean
  updatedAt: Date
  optionDealerPrice?: number | undefined
  obsoletedAt: Date | undefined;
  tags?: AssemblyTags[]
  pricingNote?: string

  msrp?: number | undefined
  upgradeDealerPrice?: number | undefined

  autoSelected: boolean;
}


export interface Assembly extends AssemblyBase {
  standardMaterialCost: number | undefined;
  standardBurdenCost: number | undefined;
  standardLaborCost: number | undefined,
  requirements: number[];
  restrictions: number[];
  dependencyRules?: string;
  createdAt: string;
  updatedAt?: string;
  assemblyDependencies: AssemblyBase[],
  fullImageUrl?: string;
  thumbnailImageUrl?: string;
  obsoletedAt: Date | undefined;
  replacementAssemblyId: number
  imported: boolean;
  category: CategoryInfo;
  operations: AssemblyOperation[];
  metadata: AssemblyMetadata[];
  labelWizard?: string
  descriptionWizard?: string
  pricingSnapshots: PricingSnapshotAssembly[];
  dashComponents?: DashComponent[];
  dealerExclusives: string[]
  customerExclusives: string[]
  customerTagExclusives?: string[]
  notes?: string
  upgradeDealerPrice?: number;
  priceDifference?: number;
  modelIds: number[];
  tags?: AssemblyTags[]
}

export interface AssemblyMetadata {
  name?: string | undefined
  valueText?: string
  valueBool?: boolean
  valueNumeric?: number
  valueDecimal?: number
  createdAt?: Date
  updatedAt?: Date
  categoryMetadata: CategoryMetadata
}

export interface CategoryMetadata {
  id: number
  name?: string | undefined
  fieldType?: string
  selectOptions?: string[]
  visibleInConfigurator?: boolean
  active?: boolean
  sortOrder?: number
}

export interface CategoryInfo {
  id: number
  name: string
  categoryId: string
  configuratorSection: string
  tags?: CategoryTags[]
}
export interface BaseCategory extends CategoryInfo {
  allowMultiple: boolean;
  excludeERPExport: boolean;
  quoteSection?: string;
  leadTimeDays: number
  procurementTimeWeeks: number
  designTimeWeeks: number
  applyDesignProcurementTime?: boolean;
  designAndProcurementWeeks?: number;
  hidden?: boolean;
  engineeringTeam?: EngineeringTeamInfo | undefined
  primaryEngineer?: User | undefined
  bomLocation?: string | undefined
}


export interface Category extends BaseCategory {
  nonDiscounted: boolean;
  nonDiscountedType?: NON_DISCOUNTED_TYPE;
  dependencyRules?: string; //CategoryRuleConfig[]
  metadata: CategoryMetadata[];
  operationId: string | undefined;
  markup?: number;
  hidden?: boolean;
  authorizedCustomers?: string[];

  notes?: string
  fullImageUrl?: string;
  thumbnailImageUrl?: string;
}

export interface CategoryRuleConfig {
  category: number
  rules: DependencyRule[]
  whenRules: DependencyRule[]
}

export interface DependencyRule {
  operator?: { id: string, name: string } | null | undefined
  field?: CategoryMetadata | null | undefined
  value?: any | null | undefined
  otherField?: string | null | undefined
  nonDiscounted?: false
  allowMultiple?: boolean;
}

export interface ConfigurationPackage {
  id: number;
  name: string;
  description: string;
  assemblies: Assembly[];
  fullImageUrl: string;
}

export interface AssemblyOperation {
  id: number
  operationId: string
  hours: number
  group: string
}

export interface Operation {
  id?: number
  operationId: string
  chassisSequence?: number
  cabSequence?: number
  current?: boolean
  defaultType?: string
}

export interface DestinationOperationSpec {
  operationName: string;
  hoursRatio: number;
}

export interface RemapOperationRequest {
  sourceOperations: string[];
  destinationCategoryOperation: string;
  cabSequence: number;
  chassisSequence: number;
  dryRun: boolean;
  destinationOperations: DestinationOperationSpec[];
}

export interface OperationsRemapResponse {
  cabSequence: number
  chassisSequence: number
  updatedCategories: OperationCategoryUpdate[]
  updatedAssemblies: OpsAssemblyUpdate[]
}

export interface OperationCategoryUpdate {
  name: string;
  operationId: string;
}

export interface OpsAssemblyUpdate {
  bom: string
  operationUpdates: AssemblyOperationUpdate[]
  operationDeletes: string[]
}

export interface AssemblyOperationUpdate {
  operationId: string
  hours: string
}

export interface ConfigurationFlowStep {
  id: number;
  title: string;
  description: string;
  order: number;
  categoryName: string;
  categoryId?: number;
  packageIds: number[];
  options: FlowAssembly[];
}

export interface ConfigurationFlow {
  id: number;
  name: string;
  flowId: string;
  steps: ConfigurationFlowStep[];
}

export interface ShippingDestination {
  id: number
  name: string
  miles: number
  centsPerMile: number
  customer?: Customer
}

export interface DealerInfo {
  id: string
  name: string
}

export interface Dealer extends DealerInfo {
  primaryContactId: number
  primaryContactName: string
  parentDealer?: DealerInfo
  salesTeams?: SalesTeam[]
  externalContacts: string[]
}

export enum SystemConfigPropertyType {
  string = "string",
  number = "number",
  bool = "bool",
}

export class SystemConfig {
  property: string;
  name: string;
  value: string;

  @Transform(({ value }) => SystemConfigPropertyType[value])
  propertyType: SystemConfigPropertyType;

  @Type(() => Date)
  createdAt: Date;

  @Type(() => Date)
  updatedAt: Date;
}

export interface UpdateSystemConfigRequest {
  value: string;
}

export enum Permission {
  TRUCK_SERIAL_NUMBERS_WRITE = 'truckSerialNumbers:write',
  LINESET_TICKET_READ = 'linesetTicket:read',
  SYSTEM_MANAGEMENT_WRITE = 'systemManagement:write',
  SET_PRODUCTION_DATE = 'productionDate:write',
  SALES_ORDER_WRITE = 'epicorSalesOrder:write',
  MASTER_SCHEDULE_READ = 'masterSchedule:read',
  MASTER_SCHEDULE_WRITE = 'masterSchedule:write',
  PRODUCTION_DATE_WRITE = 'productionDate:write',
  CHANGE_ORDER_WRITE = 'changeOrder:write',
  DASH_COMPONENT_WRITE = 'dashComponent:write',
  RULES_READ = 'rules:read',
  RULES_WRITE = 'rules:write',
  GENERATE_SERIAL_NUMBERS_WRITE = 'generateSerialNumbers:write',
  ENGINEERING_WRITE = 'engineering:write',
  ENGINEERING_READ = 'engineering:read',
  ASSEMBLY_COST_WRITE = 'assemblyCost:write',
  ASSEMBLY_COST_READ = 'assemblyCost:read',
  GENERATE_ORDER_CONFIRMATION = 'orderConfirmation:read',
  ENGINEERING_CHANGE_ORDER_WRITE = 'engineeringChangeOrder:write',
  COPY_QUOTE_WRITE = 'copyQuote:write',
  CANCEL_ORDER_WRITE = "cancelOrder:write",
  UPDATE_BOM = "updateTruckBOMToLatest:write",
  DEALER_ADMIN_READ = "dealerAdmin:read",
  DEALER_ADMIN_WRITE = "dealerAdmin:write",
  DEALER_MANAGEMENT_READ = "dealerManagement:read",
  DEALER_MANAGEMENT_WRITE = "dealerManagement:write",
  SET_QUOTE_NOTE = "quoteNote:write",
  APPROVAL_ACT_ON_RELEASE_ENGINEERING_WRITE = "approvalActOnReleaseEngineering:write",
  APPROVAL_ACT_ON_RELEASE_ENGINEERING_READ = "approvalActOnReleaseEngineering:read",
  APPROVAL_ROLE_WRITE = "approvalRole:write",
  SOURCEWELL_MANAGER = "sourcewellManager:read",
  BTS_READ = "bts:read",
  LOGISTICS_READ = "logistics:read",
  LOGISTICS_WRITE = "logistics:write",
  CONCESSION_CRITERIA_WRITE = "concessionCriteria:write",
  MASTER_SCHEDULE_PILOT_INSPECTION_WRITE = "masterSchedulePilotInspection:write",
}

export enum PermissionKey {
  APPROVAL_ACT_ON_RELEASE_ENGINEERING_WRITE = "APPROVAL_ACT_ON_RELEASE_ENGINEERING_WRITE",
  APPROVAL_ACT_ON_RELEASE_ENGINEERING_READ = "APPROVAL_ACT_ON_RELEASE_ENGINEERING_READ",
}

export enum GlobalAccessRole {
  ADMIN = 'admin',
  ENGINEERING = 'engineering',
  FINANCE = 'finance',
  SALES_MANAGER = 'sales_manager',
  SALES_DESK = 'sales_desk',
  REPORTING = 'reporting',
  PROCUREMENT = 'procurement',
  PRODUCTION = 'production',
  ENGINEERING_READ_ONLY = 'engineering_read_only',
  RELEASE_ENGINEERING = 'release_engineering',
  SCHEDULING = 'scheduling',
}

export interface ModelInfo {
  id: number
  name: string
  //motor family is defined by the assemblies
  //motorFamily?: MotorFamily,
  partNumberSuffix?: string;
}

export interface BaseModel extends ModelInfo {
  inactive: boolean
  partNumberSuffix: string
  configurationFlowId: number
  updatedAt: Date
  deleted?: boolean | undefined
}

export interface Model extends BaseModel {
  disableRules: boolean
  defaultSelections: CategoryIdAssembliesIdMap
  inheritModel: Model
  imageUrl: string
  exportHeaderHexColor: string
  operationPrefix: string
  visibleInWizard: boolean
  erpHasCabPart: boolean;
  initialConcession?: number;
  dealerExclusives: string[]
}

export interface ModelWithBasicAssemblyInfo {
  id: number;
  inactive: boolean;
  name: string | number;
  disableRules: boolean;
  bev: boolean,
  defaultSelections: CategoryIdAssembliesIdMap;
  inheritModel: ModelWithBasicAssemblyInfo;
  assemblies: AssemblyBase[];
  baseAssemblies: AssemblyBase[];
  imageUrl: string;
  exportHeaderHexColor: string;
  configurationFlowId: number;
  partNumberSuffix: string;
  operationPrefix: string;
  visibleInWizard: boolean;
  erpHasCabPart: boolean;
  initialConcession?: number;
}

// Transfer item must have key. 
export interface TruckRecord {
  key: string;
  truckSerialNumberStr: string;
}

export interface User {
  id: string,
  name: string,
  email: string,
  dealerName?: string,
  dealerId?: string,
  phoneNumber?: string,
}

export class ModelYear {
  year: number;
  designationCode: string;
}

export class Page<T> {
  @Exclude()
  type: Function;

  @Type(options => {
    return (options?.newObject as Page<T>).type;
  })
  content: T[];

  totalElements: number;
  pageable: {
    pageNumber: number
    pageSize: number
  }

  constructor(type: Function) {
    this.type = type;
  }
}

export interface QuoteDefaults {
  percentDiscount: number
  quantity: number
}

export interface EpicorExportPartsRequest {
  quoteIds: string[];
  allOrders: boolean;
}

export class EpicorExportPartsResponse {
  results: EpicorExportPartsResult[];
}

export class EpicorExportPartsResult {
  quoteId: string
  partNumber: string
  revision: string
  triggered: boolean
  success: boolean
  errors: string[]
}

export enum EpicorSyncStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}
export interface SyncStatus {
  erpSyncStatus: EpicorSyncStatus
  erpSyncMessage?: string
  erpSyncLastUpdatedAt: Date
  quoteId: string
  partNumber: string
  revision: string
}

export interface PricingOption {
  id?: string
  key: string
  label: string | undefined
  notes?: string | undefined
  value: number | undefined
}
export type NonDiscountOption = PricingOption;
export type DealerAdjustment = PricingOption;

export type PilotInspectionFee = PricingOption & {
  label: string
  value: number
  truckCnt: number
  visitorCnt: number
  includeTravel: boolean
}

export interface PricingSnapshot {
  id: number
  pricingConfigId: number
  name: string
  description?: string
  createdAt: Date
  createdBy: string
  isLatest?: boolean
}

export interface PricingSnapshotAssembly {
  id: number;
  standardMaterialCost: number;
  laborHours: number;
  laborCost: number;
  pricingSnapshot: PricingSnapshot;
}
export interface PricingConfig {
  id: number,
  createdAt: string
  createdBy: string
  active: boolean
  laborHourlyCost: number
  pdi: number
  warranty: number
  tariffsSurcharges: number
  margin: number
  dealerMarkup: number
  inboundFreight: number
  warrantyPercentage: number
  bevWarrantyPercentage: number
  commissionCost: number
  extendedWarrantyMarkup: number
  pricingSnapshot?: PricingSnapshot
  customOptionMarkup: number
  tariffConditions: TariffCondition[]
  supplementalCharges: SupplementalCharge[]
}
export interface TariffCondition {
  id: number
  engineFamily: string
  value: number
}

export interface SupplementalCharge {
  id: number
  label: string
  value: number
  //rulesv2 RuleExpression JSON; null/undefined means the charge always applies
  conditionDefinition?: string
}

export interface Truck {
  id: number
  quoteRevisionId: number
  truckSerialNumberStr: string
  vin: string;
  projectedProductionDate?: Date
  productionDate?: Date
  projectedShipDate?: Date
  shipDate?: Date
  scheduledShipDate?: Date
  readyToShip?: Date
  estReadyToShip?: Date
  projectedReadyToShip?: Date
  notes?: string;
  engineSerialNumber?: string
  transmissionSerialNumber?: string
  purchaseOrder?: string
  physicalLocation?: string
  shipped?: boolean
  steerAxle1?: string;
  steerAxle2?: string;
  steerAxle3?: string;
  pusherAxle1?: string;
  driveAxle1?: string;
  driveAxle2?: string;
  driveAxle3?: string;
  tagAxle?: string;
  scr?: string;
  dpf?: string;
  epicorProductionDate?: string;
  epicorShipDate?: string;
  epicorReadyToShip?: string;
  epicorProductionStatus?: string;
  productionLine?: string;
  productionSlot?: number;
  tags?: TruckTags[]
  pilotInspectionDate?: Date
}

export interface PoNumber {
  id: number
  poNumber: string
  amount: number | undefined
  documents: DocumentAsset[]
}

export interface DocumentAsset {
  id: number
  filename: string
  contentType: string
  assetUri: string
}

export interface AssemblyDocument {
  id: number
  assemblyId: number
  bom: string
  assemblyLabel?: string
  filename: string
  contentType: string
  assetUri: string
  url?: string
  createdAt?: string
  createdBy?: string
}

export interface QuoteInfo {
  id: number
  quoteRevisionId: number
  quoteId: string
  revision: number
  name: string
}

export interface QuoteDisplayStatus {
  major: string
  minor?: string
}

export interface BaseQuote {
  id: number
  version: string //uuid
  quoteId: string
  name: string
  modelYear: number
  stock: boolean
  partNumberString?: string | undefined
  poNumber?: PoNumber | undefined
  quantity: number
  displayStatus:QuoteDisplayStatus
  createdAt: Date
  createdBy: string
  updatedAt: Date
  updatedBy: string
  owner?: User | undefined
  productionDate?: Date | undefined
  serialNumberStr?: string
  selectionSummary: CategoryIdAssembliesMap
  model: ModelInfo
  displayRevisionId: number
  salesOrderNumber?: number
  truckDescription?: string
  expired?: boolean
  cancelled?: boolean
  shipped?: boolean
  revision: number
  revisionType: RevisionType
  epicorRevision?: string
  epicorDisabled?: boolean | undefined
  engineeringStatusHot?: boolean
  reservation?: boolean
  salesTeam?: SalesTeam
  archived?: boolean
  abandoned?: boolean
  revisionApprovalStatus: RevisionApprovalStatus
  totalPrice?: number
  dealerPrice?: number
}

export interface QuoteReview {
  customOptions?: Record<string, CustomOptionType>
  invalidAssemblyLst?:Record<string,  AssemblyInfo>
  obsoleteAssemblyLst?: Record<string, AssemblyInfo>
  missingCategoryLst?: Record<string, BaseCategory>
  performance?: Performance | undefined
  dashImageUrl?: string
}

export interface Quote extends BaseQuote {
  quoteShares?: QuoteShare[] | undefined
  selections: CategoryIdAssembliesIdMap
  selectedCustomOptions: CategoryIdCustomOptionIdMap
  selectionNotes: any;
  notes?: string;
  currentRevisionId: number;
  pricingConfig: PricingConfig;
  endCustomer?: Customer | undefined,
  dealerCustomer: Customer;
  shippingDestination?: ShippingDestination;
  percentDiscount: number;
  salesRequests?: string;
  latestApproval: Approval | undefined;
  trucks?: Truck[] | undefined;
  revisions: Revision[];
  dealerAdjustmentList: DealerAdjustment[];
  nonDiscountOptionList: NonDiscountOption[];
  pilotInspectionFee: PilotInspectionFee
  gvwrCap: number | undefined;
  shippingDate: Date | undefined;
  changeSummary: string | undefined;
  incentivePrograms: IncentiveProgramInfo[];
  customerShippingDate: Date | undefined;
  truckCustomerShippingDateList: TruckRequestedShippingDto[] | undefined;
  cadence: string;
  truckDescription?: string;
  latestRevisionId: number
  effectiveRevisionId: number
  lockedByEngineer: User
  stateRegistration: string | undefined
  priceProtected: boolean
  orderProbability: string | undefined
  expectedOrderDate: Date | undefined
  expectedShipDate: Date | undefined
  approvalGroups?: ApprovalGroup[]
  parent: QuoteInfo
  hasWritePermission?: boolean
  motorFamily?: MotorFamily
  pricingBreakdown?: PricingBreakdown
  leadTime: number | undefined
  orderApprovalDate?: Date | undefined
  quoteApprovalDate?: Date | undefined
}

export interface TruckRequestedShippingDto {
  truckId: number,
  serialNumber: string,
  truckCustomerShippingDate: Date,
}

export interface NeedVerifyDash {
  hasUnassignedComponents: boolean;
}

export interface Approval {
  id: number;
  action: ApprovalAction | undefined
  createdAt: Date
  actionedAt: Date
  actionedBy?: User
  submittedBy?: User
  submittedAt?: Date
  approvalType: ApprovalRequest

  workingNote?: string | undefined;
  actionNotes?: string | undefined;
  notes?: string;

  changeSummary: string
  approvalStep: ApprovalStepInfo
  approvalGroup?: ApprovalGroup
  approver: boolean

  userApprovalIp?: string

  quoteInfo: ApprovalQuoteInfo
}

export interface ApprovalQuoteInfo {
  id: number
  name: string
  quoteId: string
  revision: number
  revisionType: RevisionType
  revisionApprovalStatus: RevisionApprovalStatus
  quoteRevisionId: number
  partNumberString?: string | undefined
  serialNumberStr?: string
  productionDate?: Date | undefined
  reservation?: boolean
}

export interface QuoteRevisionDiff {
  assembliesDiff?: {
    addedAssemblies?: AssemblyInfo[],
    removedAssemblies?: AssemblyInfo[];
  };
  customOptionsDiff?: {
    addedCustomOptions?: CustomOptionType[],
    removedCustomOptions: CustomOptionType[];
  };
  dealerCustomerDiff?: QuoteDiffItem;
  endCustomerDiff?: QuoteDiffItem;
  shippingDestinationDiff?: QuoteDiffItem;
  gvwrCapDiff?: QuoteDiffItem;
  nameDiff?: QuoteDiffItem;
  modelDiff?: QuoteDiffItem;
  modelYearDiff?: QuoteDiffItem;
  pricingConfigDiff?: QuoteDiffItem;
  productionDateDiff?: QuoteDiffItem;
  shippingDateDiff?: QuoteDiffItem;
  percentDiscountDiff?: QuoteDiffItem;
  quantityDiff?: QuoteDiffItem;
  notesDiff?: QuoteDiffItem;
  salesRequestsDiff?: QuoteDiffItem;
  poNumberDiff?: QuoteDiffItem;
  partNumberMajor?: QuoteDiffItem;
  stateRegistrationDiff?: QuoteDiffItem;
  partNumberDiff?: QuoteDiffItem;
  nonDiscountOptionsDiff?: {
    newNonDiscountOptions: NonDiscountOption[];
    oldNonDiscountOptions: NonDiscountOption[];
    oldPrice?: number;
    newPrice?: number;
  };
  dealerAdjustmentsDiff?: {
    newDealerAdjustments: DealerAdjustment[];
    oldDealerAdjustments: DealerAdjustment[];
    oldPrice?: number;
    newPrice?: number;
  };
  serialNumbersDiff?: QuoteDiffItem;
  vinDiff?: QuoteDiffItem;
  revisionType?: RevisionType
  priceDiff?: QuoteDiffItem;
  truckDiff?: { oldTruck: Truck[], newTruck: Truck[] };
  salesTeamDiff?: QuoteDiffItem;
}

export enum DateFilterType {
  Creation = "Creation",
  Production = "Production",
  Approval = "Approval",
  Shipping = "Shipping",
  Cancellation = "Cancellation",
}

export enum RevisionType {
  CHANGE_ORDER = "CHANGE_ORDER",
  SPLIT_ORDER = "SPLIT_ORDER",
  ENGINEERING_CHANGE = "ENGINEERING_CHANGE",
  CANCEL_ORDER = "CANCEL_ORDER",
}


export enum ApprovalRequest {
  QUOTE_APPROVAL = 'QUOTE_APPROVAL',
  ORDER = 'ORDER',
  CHANGE_ORDER = 'CHANGE_ORDER',
  ENGINEERING_CHANGE = "ENGINEERING_CHANGE",
  CANCEL_ORDER = 'CANCEL_ORDER',
}

export enum ApproverRole {
  ENGINEERING = 'ENGINEERING',
  PROCUREMENT = 'PROCUREMENT',
  FINANCE = 'FINANCE',
  SALES_DESK = 'SALES_DESK',
  SALES_MANAGER = 'SALES_MANAGER',
  RELEASE_ENGINEERING = 'RELEASE_ENGINEERING',
  SCHEDULING = 'SCHEDULING',
  BM_REPRESENTATIVE = 'BM_REPRESENTATIVE',
}

export enum ApprovalAction {
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum ChangeOrderDiff {
  DEALER_CUSTOMER_DIFF = 'dealerCustomerDiff',
  END_CUSTOMER_DIFF = 'endCustomerDiff',
  SHIPPING_DESTINATION_DIFF = 'shippingDestinationDiff',
  GVWR_CAP_DIFF = 'gvwrCapDiff',
  NAME_DIFF = 'nameDiff',
  MODEL_DIFF = 'modelDiff',
  MODEL_YEAR_DIFF = 'modelYearDiff',
  PRICING_CONFIG_DIFF = 'pricingConfigDiff',
  PRODUCTION_DATE_DIFF = 'productionDateDiff',
  SHIPPING_DATE_DIFF = 'shippingDateDiff',
  PERCENT_DISCOUNT_DIFF = 'percentDiscountDiff',
  QUANTITY_DIFF = 'quantityDiff',
  NOTES_DIFF = 'notesDiff',
  SALES_REQUESTS_DIFF = 'salesRequestsDiff',
  PO_NUMBER_DIFF = 'poNumberDiff',
  PART_NUMBER_MAJOR = 'partNumberMajor',
  ASSEMBLIES_DIFF = 'assembliesDiff',
  NON_DISCOUNT_OPTION_DIFF = 'nonDiscountOptionsDiff',
  DEALER_ADJUSTMENT_DIFF = 'dealerAdjustmentsDiff',
  SERIAL_NUMBERS_DIFF = 'serialNumbersDiff',
  VIN_DIFF = 'vinDiff',
  PART_NUMBERS_DIFF = 'partNumberDiff',
  TRUCK_DIFF = 'truckDiff',
  SALES_TEAM_DIFF = 'salesTeamDiff',
  STATE_REGISTRATION = 'stateRegistrationDiff',
}

export interface QuoteDiffItem {
  before: string,
  after: string,
  item: string,
  beforePrice: number | undefined,
  afterPrice: number | undefined,
}

export interface QuoteRevisionHistory {
  approvals: Approval[] | undefined,
  firstApproval: Approval | undefined,
  latestApproval: Approval | undefined,
  diff: QuoteRevisionDiff | undefined,
  revision: Revision
  prevRevision?: Revision
  approvalGroups?: ApprovalGroup[]
}

export enum MajorTableExcludedDiff {
  ASSEMBLIES_DIFF = 'assembliesDiff',
  NON_DISCOUNT_OPTION_DIFF = 'nonDiscountOptionsDiff',
  DEALER_ADJUSTMENT_DIFF = 'dealerAdjustmentsDiff',
  REVISION_TYPE = 'revisionType',
  PRICE_DIFF = 'priceDiff',
  TRUCK_DIFF = 'truckDiff',
}

export enum NewOrOld {
  NEW = 'new',
  OLD = 'old',
}

export interface Revision {
  id: number;
  quoteId: string;
  revision: number;
  revisionType?: RevisionType
  erpRevisionNum?: number;
  revisionString?: string;
  revisionApprovalStatus?: RevisionApprovalStatus
  createdBy?: User
  createdAt?: Date
  abandoned: boolean
  reservation?: boolean
  changeSummary?: string
  parent: QuoteInfo
}

export interface AssemblyOption extends AssemblyBase {

  obsoletedAt: Date
  selectionRequiresUserInput: boolean
  metadata: AssemblyMetadata[]

  upgradeDealerPrice: number
  priceDifference: number;

  incompatible?: string

  notes?: string
  fullImageUrl?: string;
  thumbnailImageUrl?: string;
}

export class ModelComputeOptionsResponse {
  options?: Assembly[];
  selections: CategoryIdAssembliesIdMap
  filteredAssemblies?: Assembly[];
  category?: Category;
  fullPricing: PricingBreakdown;
  limitedPricing: PricingBreakdown;
  ruleDebugOutput?: RuleDebugOutput;
}

export interface PricingBreakdown {
  materialPrice: number;
  laborPrice: number;
  cost: number;
  pdi: number;
  warranty: number;
  tariffsSurcharges: number;
  customerTariffs: number;
  supplementalCharges: SupplementalCharge[];
  inboundFreight: number;
  grossMargin: number;
  dealerNet: number;
  customOptionsMsrp: number;
  dealerMsrp: number;
  nonDiscountedPrice: number;
  dealerDiscount: number;
  dealerDiscountedNet: number;
  shippingDestination: number;
  totalPrice: number;
  baseMsrp?: number;
  optionsMsrp?: number;
  percentDiscount: number;
  commissionCost: number;
  dealerPrice: number;
  priceMatch?: number;
  incentivePrograms: IncentiveProgram[]
  nonDiscountedItems: Assembly[];
  nonDiscountedNetItems: Assembly[];
  dealerAdjustments: DealerAdjustment[]
  nonDiscountOptions: NonDiscountOption[]
}

export class ListUsersRequest {
  filter?: string;
  dealerId?: string;
}

export class ExternalUser {
  id: string;
  email: string;
  name: string;
  dealer: Dealer;
  enabled: boolean;
  userType: string;
  phoneNumber: string;
}

export interface CreateUserRequest {
  name: string;
  email: string;
  dealerId: string;
  enabled: boolean;
  userType: string;
}

export interface CustomOptionType {
  id: number
  key: string
  content?: string | undefined
  price?: number
  upgradePrice?: number
  dealerPrice?: number
  upgradeDealerPrice?: number | undefined
  approved?: boolean | undefined
  note?: string
  createdAt?: string
  updatedAt?: string
  updatedBy?: string
  included?: boolean
  designAndProcurementWeeks?: number
  quoteRevisionId?: number
  customOptionOrder?: number
  category?: CategoryInfo

  standardMaterialCost?: number
  laborHours?: number
  laborCost?: number
  metadata?: AssemblyMetadata[];
  disableUpcharge?: boolean
}

export interface ChangeLeadTime {
  shippingDestinationLeadTime: number;
  standardLeadTimeWeeks: number;
  categoryLeadTimeDays?: number;
  leadTimeCategories?: CategoryInfo[]
}

export interface SplitQuoteDto {
  quoteId: string;
  trucksToBeSplit?: number[][];
  splitQuantity?: number;
  updatedQuoteName?: string;
  newQuoteNames?: string[];
}

export interface SortRequestParam {
  field: string
  direction: SortDirection
}

export interface ChangeOrderVerificationRequest {
  quoteId: number;
  verifyingRevisionId: number;
  compareCurrentRevision: boolean;
}

export type SortDirection = 'asc' | 'desc';

export interface Customer {
  id: number
  name?: string
  addressLine1?: string
  addressLine2?: string
  city?: string
  stateProvince?: string
  postalCode?: string
  countryCode?: string
  enteredByUser?: string
  contactName?: string
  contactTitle?: string
  contactRole?: string
  contactPhone?: string
  contactEmail?: string
  dealerId?: string
  entityType?: string
  tags?: string[]
}

export interface AddressDto {
  address: Customer;
  defaultAddress: boolean;
}

export interface DefaultAddress {
  customerId: number;
  defaultAddress: boolean;
}

export interface Performance {
  performanceData?: PerformanceData;
  performanceWeight?: PerformanceWeight;
  performanceDimension?: PerformanceDimension;
  modelType: string;
}

export interface PerformanceWeight {
  model: ItemWeights;
  axle: ItemWeights;
  suspension: ItemWeights;
  wheels: ItemWeightsWithUnits;
  tires: ItemWeightsWithUnits;
  gawr: ItemWeights;
  tare: ItemWeights;
  chassisGVWR: string;
  engineGVWR: string;
  transmissionGVWR: string;
  chassisWeight: string;
  truckGVWRLimit: number;
  truckGVWR: number;
  availGVWR: string;
  weightsMissing: string[];
  tareMissing: string[];
  gvwrMissing: string[];
}

export interface ItemWeightsWithUnits {
  front: WeightAndUnit;
  pusher: WeightAndUnit;
  firstIntermediate: WeightAndUnit;
  lastDrive: WeightAndUnit;
  tag: WeightAndUnit;
}

export interface ItemWeights {
  front: string;
  pusher: string;
  firstIntermediate: string;
  lastDrive: string;
  tag: string;
}

export interface WeightAndUnit {
  weight: string;
  unit: string;
  total: string;
}

export interface PerformanceDimension {
  wheelbase: string;
  frameSillLength: string;
  afterFrame: string;
  cabToAxle: string;
  pusherTagSpacing: string;
  bumperToFrontAxle: string;
  frameHeightRearLaden: string;
  frameHeightRearUnladen: string;
  cabWidth: string;
  mirrorWidth: string;
  overallLength: string;
  dimensionMissing: string[];
  centerlineToTireCenterline: string;
  curbToCurb: string;
  wallToWall: string;
  frameSlope: string;
  cgPusher: string;
  cgTag: string;
}

export interface PerformanceData {
  gradeability: string;
  wheelslip?: string;
  accelerationRate?: string;
  startability: string;
  gearedSpeed: string;
  accelerationRateAlert: boolean;
  gradeabilityAlert: boolean;
  startabilityAlert: boolean;
  wheelslipAlert: boolean;
  gearedSpeedAlert: boolean;
  performanceMissing: string[];
}

export interface UpdateAssemblySnapshotCostsRequest {
  pricingSnapshotAssemblyIds: number[];
  standardMaterialCost?: number;
  laborHours?: number;
}

export class EpicorCustomersResponse {
  customers: EpicorCustomer[];
}

export interface EpicorCustomer {
  company: string;
  custID: string;
  custNum: number;
  name: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  shipTos: EpicorShipTo[];
}

export interface EpicorShipTo {
  shipToNum: string;
  name: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}

export interface EpicorExportSalesOrderRequest {
  quoteRevisionId: number;
  billToCustomerId: string;
  shipToCustomerId: string;
  shipToNum?: string;
  custNum: number;
  shipDate: string;
}

export class EpicorExportSalesOrderResponse {
  salesOrderNumber: string;
  partsDeleted: { [key: string]: number; };
  partsAdded: { [key: string]: number; };
  closedLinesSkipped?: string[];
}

export class EpicorSalesOrder {
  billToId: string;
  billToCustomer: EpicorCustomer;
  shipToId: string;
  shipToNum: string;
  shipToCustomer: EpicorCustomer;
  salespersonId: string;
  shipDate: Date;
  custNum: number;
  customer: EpicorCustomer;
}

export class AssemblyCost {
  id: number
  standardMaterialCost: number
  status: string
  createdBy: string
  user?: User
  assembly: Assembly
}

export interface RevisionChangeDto {
  changeSummary: string
  diffDto: QuoteRevisionDiff
  priorRevisionId: string
  latterRevisionId: string
  revisionType: RevisionType
  erpRevisionNum: number
  revisionString: string
  createdAt: Date
  createdBy: string
}

export interface DashComponent {
  id: number;
  partNumber: string;
  description: string;
  type?: string;
  imageUrl?: string;
  iconImageUrl?: string;
  quantity?: number;
}

export interface DashTemplate {
  id: number;
  partNumber: string;
  description: string;
  imageUrl?: string;
  editedImageUrl?: string;
  locations?: TemplateLocation[];
  assemblies: number[];
  assembliesStr?: string[];
  optionStartingX?: number;
  optionStartingY?: number;
  optionColumnWidth?: number;
}

export interface DashDrawingUrl {
  url: string;
  unassignedComponents: UnassignedComponent[];
  uploadDashImage: boolean;
}

export interface UnassignedComponent {
  component: string;
  quantity: number;
  assigningAssemblies: Record<string, number>;
}

export interface TemplateRelatedQuote {
  id: string;
  partNumber: string;
  description: string;
  quantity: string;
}

export interface QuoteWithMissingDashComponent {
  id: number;
  quoteId: string;
  quoteName: string;
  unassignedComponents: UnassignedComponent[];
}

export type ComponentType = 'SWITCH_LIGHT' | 'GUAGE' | 'COVER' | 'JOYSTICK' | 'BREAK_VALVE';

export interface TemplateLocation {
  selected: boolean;
  location: string | undefined;
  coordinateX?: string | undefined;
  coordinateY?: string | undefined;
  type?: ComponentType | undefined;
  components: number[] | undefined;
  legendCoordinateX?: string | undefined;
  legendCoordinateY?: string | undefined;
  locationOrder: number;
}

export enum ComponentMap {
  SWITCH_LIGHT = 'switch_light',
  GAUGE = 'gauge',
  JOYSTICK = 'joystick',
  COVER = 'cover',
  BREAK_VALVE = 'break_valve',
  SWITCH_LIGHT_LARGE = 'switch_light_large',
  GAUGE_LARGE = 'gauge_large',
  JOYSTICK_LARGE = 'joystick_large',
  BREAK_VALVE_LARGE = 'break_valve_large',
}

export interface SourcewellLetterParameters {
  dealerName: string
  dealerContactName: string
  dealerAddress: string
  destinationName: string
  destinationAddress: string
  truckName: string
  customerGreeting: string
}

export interface CreateRuleSetRequest {
  name: string;
  copyFromRuleSetId?: number;
}

export class RuleSet {
  id: number;
  name: string;

  @Type(() => Date)
  createdAt: Date;

  @Type(() => Date)
  updatedAt: Date;

  ruleSet?: string;
  active?: boolean;
}

export function parseExpression(type: any, value: any) {
  switch (type) {
    case 'and':
      return plainToClass(AndExpression, value);
    case 'equals':
      return plainToClass(EqualsExpression, value);
    case 'not-equals':
      return plainToClass(NotEqualsExpression, value);
    case 'global':
      return plainToClass(GlobalExpression, value);
    case 'gte':
      return plainToClass(GteExpression, value);
    case 'gt':
      return plainToClass(GtExpression, value);
    case 'lt':
      return plainToClass(LtExpression, value);
    case 'lte':
      return plainToClass(LteExpression, value);
    case 'or':
      return plainToClass(OrExpression, value);
    case 'not':
      return plainToClass(NotExpression, value);
    case 'category-has-selection':
      return plainToClass(CategoryHasSelectionExpression, value);
    case 'selection-has-metadata-option':
      return plainToClass(SelectionHasMetadataOptionExpression, value);
    case 'existing-selection-matches':
      return plainToClass(ExistingSelectionMatchesExpression, value);
    default:
      return value;
  }
}

export function ruleExpressionTransform(params: TransformFnParams) {
  return parseExpression(params.value.type, params.value);
}

function ruleExpressionArrayTransform(params: TransformFnParams) {
  return params.value.map(val => ruleExpressionTransform({ ...params, value: val }))
}

export enum RuleValueTypes {
  Metadata = 'metadata',
  String = 'string',
  Numeric = 'numeric',
  AssemblyAttribute = 'assembly-attribute',
  MetadataSelectOption = 'metadata-option',
  Boolean = 'boolean',
  Attribute = 'attribute',
  Date = 'date',
  Model = 'model',
}


export class RuleValue {
  type: string;
}

export class DateValue extends RuleValue {
  date: string;
  type = RuleValueTypes.Date;
}

export class ModelValue extends RuleValue {
  modelId: number;
  type = RuleValueTypes.Model;
}

export class MetadataValue extends RuleValue {
  category: string;
  field: string;
  type = RuleValueTypes.Metadata;
}

export class StringValue extends RuleValue {
  value: string = '';
  type = RuleValueTypes.String;
}

export class NumericValue extends RuleValue {
  value: number = 0;
  type = RuleValueTypes.Numeric;
}

export enum AssemblyAttribute {
  categoryId, bom
}

export enum RuleAttribute {
  currentDate = "currentDate",
  quoteCreatedDate = "quoteCreatedDate",
  quoteStateRegistration = "quoteStateRegistration",
  quoteProductionDate = "quoteProductionDate",
  firstTruckShipDate = "firstTruckShipDate",
  firstTruckReadyToShipDate = "firstTruckReadyToShipDate",
  firstTruckScheduledShipDate = "firstTruckScheduledShipDate",
  firstTruckScheduledShipYear = "firstTruckScheduledShipYear",
  lastTruckScheduledShipYear = "lastTruckScheduledShipYear",
  model = "model",
  modelYear = "modelYear",
  quantity = "quantity",
  endCustomer = "endCustomer",
  destination = "destination",
  isOrder = "isOrder",
  truckGvwr = "truckGvwr",
  cgPusher = "cgPusher",
  cgTag = "cgTag",
}

export class AssemblyAttributeValue extends RuleValue {
  attribute: AssemblyAttribute;
  type = RuleValueTypes.AssemblyAttribute;
}

export class AttributeValue extends RuleValue {
  attribute: RuleAttribute;
  type = RuleValueTypes.Attribute;
}

export class MetadataSelectOption extends RuleValue {
  categoryId: string;
  field: string;
  value: string;
  type = RuleValueTypes.MetadataSelectOption;
}

export class BooleanValue extends RuleValue {
  value: boolean = false;
  type = RuleValueTypes.Boolean;
}

export const RuleValueType = {
  keepDiscriminatorProperty: true,
  discriminator: {
    property: 'type',
    subTypes: [
      { value: MetadataValue, name: RuleValueTypes.Metadata },
      { value: StringValue, name: RuleValueTypes.String },
      { value: NumericValue, name: RuleValueTypes.Numeric },
      { value: AttributeValue, name: RuleValueTypes.Attribute },
      { value: DateValue, name: RuleValueTypes.Date },
      { value: ModelValue, name: RuleValueTypes.Model },
      { value: AssemblyAttributeValue, name: RuleValueTypes.AssemblyAttribute },
      { value: MetadataSelectOption, name: RuleValueTypes.MetadataSelectOption },
      { value: BooleanValue, name: RuleValueTypes.Boolean },
    ]
  }
};

export class RuleExpression {
  type: string;
  categoryId?: string;
  category?: string;
  expressions?: RuleExpression[];
}

export class CategoryHasSelectionExpression extends RuleExpression {
  category: string;
  type = 'category-has-selection';
}

export class SelectionHasMetadataOptionExpression extends RuleExpression {
  categoryId: string;
  field: string;
  value: string;
  type = 'selection-has-metadata-option';
}
export class ExistingSelectionMatchesExpression extends RuleExpression {
  @Type(() => AssemblyAttributeValue, RuleValueType)
  lhs: RuleValue = new AssemblyAttributeValue();

  @Type(() => RuleValue, RuleValueType)
  rhs: RuleValue = new RuleValue();

  type = 'existing-selection-matches';
}
export class EqualsExpression extends RuleExpression {
  @Type(() => RuleValue, RuleValueType)
  lhs: RuleValue = new RuleValue();

  @Type(() => RuleValue, RuleValueType)
  rhs: RuleValue = new RuleValue();

  type = 'equals';
}

export class AndExpression extends RuleExpression {
  @Transform(ruleExpressionArrayTransform)
  expressions: RuleExpression[] = [];

  type = 'and';
}
export class GlobalExpression extends RuleExpression {
  name: string = '';
  type = 'global';
}

export class LhsRhsExpression extends RuleExpression {
  @Type(() => RuleValue, RuleValueType)
  lhs: RuleValue = new RuleValue();

  @Type(() => RuleValue, RuleValueType)
  rhs: RuleValue = new RuleValue();
}

export class NotEqualsExpression extends LhsRhsExpression {
  @Type(() => RuleValue, RuleValueType)
  lhs: RuleValue = new RuleValue();

  @Type(() => RuleValue, RuleValueType)
  rhs: RuleValue = new RuleValue();

  type = 'not-equals';
}


export class GteExpression extends LhsRhsExpression {
  @Type(() => RuleValue, RuleValueType)
  lhs: RuleValue = new RuleValue();

  @Type(() => RuleValue, RuleValueType)
  rhs: RuleValue = new RuleValue();

  type = 'gte';
}
export class GtExpression extends LhsRhsExpression {
  @Type(() => RuleValue, RuleValueType)
  lhs: RuleValue = new RuleValue();

  @Type(() => RuleValue, RuleValueType)
  rhs: RuleValue = new RuleValue();

  type = 'gt';
}
export class LtExpression extends LhsRhsExpression {
  @Type(() => RuleValue, RuleValueType)
  lhs: RuleValue = new RuleValue();

  @Type(() => RuleValue, RuleValueType)
  rhs: RuleValue = new RuleValue();

  type = 'lt';
}
export class LteExpression extends LhsRhsExpression {
  @Type(() => RuleValue, RuleValueType)
  lhs: RuleValue = new RuleValue();

  @Type(() => RuleValue, RuleValueType)
  rhs: RuleValue = new RuleValue();

  type = 'lte';
}
export class MatchesExpression extends LhsRhsExpression {
  @Type(() => RuleValue, RuleValueType)
  lhs: RuleValue = new RuleValue();

  @Type(() => RuleValue, RuleValueType)
  rhs: RuleValue = new RuleValue();

  type = 'matches';
}
export class NotExpression extends RuleExpression {
  @Transform(ruleExpressionTransform)
  expression: RuleExpression = new RuleExpression();

  type = 'not';
}
export class OrExpression extends RuleExpression {
  @Transform(ruleExpressionArrayTransform)
  expressions: RuleExpression[] = [];

  type = 'or';
}

function RuleExpressionType() {
  return {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: [
        { value: CategoryHasSelectionExpression, name: 'category-has-selection' },
        { value: SelectionHasMetadataOptionExpression, name: 'selection-has-metadata-option' },
        { value: ExistingSelectionMatchesExpression, name: 'existing-selection-matches' },
        { value: EqualsExpression, name: 'equals' },
        { value: NotEqualsExpression, name: 'not-equals' },
        { value: AndExpression, name: 'and' },
        { value: GlobalExpression, name: 'global' },
        { value: GteExpression, name: 'gte' },
        { value: GtExpression, name: 'gt' },
        { value: LtExpression, name: 'lt' },
        { value: LteExpression, name: 'lte' },
        { value: NotExpression, name: 'not' },
        { value: OrExpression, name: 'or' },
        { value: MatchesExpression, name: 'matches' },
      ]
    }
  };
}


export class RuleAction {
  categoryId?: string;
  ruleId: number;
  name: string;
  type: string;
  disabled: boolean;

  actionName(): string {
    return 'undefined';
  }

  filterCategories(): string[] {
    return [];
  }
  conditionCategories(): string[] {
    return [];
  }

  walkExpressions = (exp: any): string[] => {
    if (exp === undefined) return [];

    const rslt = new Array<string>();
    if (exp.category) rslt.push(exp.category);
    if (exp.categoryId) rslt.push(exp.categoryId);

    rslt.push(...this.walkExpressions(exp.condition));
    rslt.push(...this.walkExpressions(exp.expression));
    exp.expressions?.forEach((f: any) => {
      rslt.push(...this.walkExpressions(f));
    });

    return rslt;
  }
}

export class FilterAssembliesIfNoneMatchAction extends RuleAction {
  @Type(() => FilterAssembliesIfNoneMatchActionDetails)
  details: FilterAssembliesIfNoneMatchActionDetails[] = [];

  type = 'filterAssembliesIfNoneMatch';

  actionName(): string {
    return 'Filter Assemblies';
  }

  filterCategories(): string[] {
    const rslt = new Array<string>();
    this.details.forEach(d => {
      d.filters.forEach(f => {
        rslt.push(...this.walkExpressions(f));
      });
    })

    return [...(new Set(rslt))];
  }

  conditionCategories(): string[] {
    const rslt = new Array<string>();
    this.details.forEach(d => {
      rslt.push(...this.walkExpressions(d.condition));
    })

    return [...(new Set(rslt))];
  }

}

export class FilterAssembliesIfNoneMatchActionFilter {
  categoryId: string;

  @Type(() => RuleExpression, RuleExpressionType())
  expression: RuleExpression = new RuleExpression();
}

export class FilterAssembliesIfNoneMatchActionDetails {
  @Type(() => RuleExpression, RuleExpressionType())
  condition: RuleExpression = new RuleExpression();

  @Type(() => FilterAssembliesIfNoneMatchActionFilter)
  filters: FilterAssembliesIfNoneMatchActionFilter[] = [];
  expressions: RuleExpression[];
}

export class RuleExpressionStub {
  @Type(() => RuleExpression, RuleExpressionType())
  expression: RuleExpression;
}

export interface GlobalExpressionDetails {
  id: string;
  definition: GlobalExpressionDefinition;
}

export class RuleSetDefinition {
  globalExpressions: Map<string, RuleExpression>;

  @Type(() => RuleAction, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: [
        { value: FilterAssembliesIfNoneMatchAction, name: 'filterAssembliesIfNoneMatch' },
      ]
    }
  })
  rules: RuleAction[];
}

export interface UpdateRuleRequest {
  rule: RuleAction;
}

export interface CreateRuleRequest {
  rule: RuleAction;
}

export interface DeleteRuleRequest {
  ruleId: number;
}

export class GlobalExpressionDefinition {
  name: string;

  @Type(() => RuleExpression, RuleExpressionType())
  expression: RuleExpression = new RuleExpression();
}

export interface CreateGlobalExpressionRequest {
  definition: GlobalExpressionDefinition;
}

export interface UpdateGlobalExpressionRequest {
  id: string;
  definition: GlobalExpressionDefinition;
}

export class RuleDebugOutput {
  filteredAssemblies: FilteredAssemblyDebug[];
}

export class FilteredAssemblyDebug {
  ruleCategory: string;
  category: number;
  ruleBody: string;
  bom: string;
  label: string;
  ruleSetId?: number;
  ruleId: number;
  ruleName: string;

  @Type(() => RuleExpression, RuleExpressionType())
  ruleExpression: RuleExpression;
}

export interface IncentiveProgramInfo {
  id: string
  name: string
  family?: string
  percentDiscount?: number
  enabled: boolean
}
export interface IncentiveProgram extends IncentiveProgramInfo {
  description: string
  cost?: number
  dealerAdjustment?: DealerAdjustment
}

export interface QuoteFilter {
  search?: string;
  includingArchived?: boolean;
  myQuotes?: boolean;
  dealerLst?: string[];
  filterAssemblies?: number[];
  ordersOnly?: boolean;
  includeReservations?: boolean;
  incentivePrograms?: string[];
  quoteStatus?: string[];
  salespersons?: string[] | undefined;
  engineers?: string[] | undefined;
  endCustomerId?: number[];
  shippingDestinationId?: number[];
  dateFilterType?: DateFilterType;
  dateFilterStart?: Dayjs;
  dateFilterEnd?: Dayjs;
  includingCancelledOrder?: boolean;
  entityTypes?: string[];
  hasCustomOptions?: boolean;
  hasDraftRevision?: boolean;
  primarySalesId?: string;
  models?: number[];
  stock?: boolean
  stateRegistration?: string[] | undefined;
  rowPerUnit?: boolean
  truckTags?: TruckTags[] | undefined;
}

export interface ApprovalFilter {
  search?: string;
  requestedBy: string[] | undefined
  engineers: string[] | undefined
  sales: string[] | undefined
  approvalType: ApprovalRequest[] | undefined
  approverRole: ApproverRole[] | undefined
  actioned: boolean | undefined
  models: string[] | undefined
}

export interface QuoteStatusVerification {
  needRefresh: boolean;
  messages: string[];
}
export enum AssemblyExceptionOperation {
  ADD = "ADD",
  REMOVE = "REMOVE",
}
export enum AssemblyExceptionType {
  OBSOLETE = "OBSOLETE",
  RULE_OVERRIDE = "RULE_OVERRIDE",
  TEMP_DEMAND = "TEMP_DEMAND"
}

export interface QuoteAssemblyException {
  id?: number
  operation: AssemblyExceptionOperation
  type: AssemblyExceptionType
  assembly: AssemblyInfo
  reason: string
  createdBy?: User
  createdAt?: Date
}

export interface ProcessError {
  id: number
  message: string
}

export interface UploadHistory {
  createdAt: Date
  userName: string
  status: string
  uploadUrl: string
}


export interface CabStyle {
  name: string
  description: string
  valueText: string
}

export interface FuelType {
  name: string
  description: string
  valueText: string
}

export interface InternalUser {
  userId: string
  userRolePermissions: PermissionKey[]
  managers?: User[]
  subordinates?: User[]
}

export interface FilterOption {
  mdId: number,
  filterOptions: Array<string | number>
}

export interface ScheduleFilterOptionDto {
  productionLine: ScheduleFilterOption
  dealerName: ScheduleFilterOption
  customerName: ScheduleFilterOption
  modelName: ScheduleFilterOption
  fuelType: ScheduleFilterOption
  cabStyle: ScheduleFilterOption
  pilotInspection: ScheduleFilterOption
  productionStatus: ScheduleFilterOption
  truckSerialNumberStr: ScheduleFilterOption
  projectedProductionDate: ScheduleFilterOption
  projectedReadyToShip: ScheduleFilterOption
  projectedShipDate: ScheduleFilterOption
}

export interface ScheduleFilterOption {
  column: string
  options: Array<string | number>
  sorting: 'asc' | 'desc'
}

export enum CommentTopic {
  UserComment = "USER_COMMENT",
  VfdReview = "VFD_REVIEW",
  SystemActivity = "SYSTEM_ACTIVITY",
  BTS = "BTS",
  Documents = "DOCUMENTS",
}

export interface NewComment {
  topic: CommentTopic
  text?: string
  internal?: boolean
  documents?: DocumentAsset[]
  hidden?: boolean
  tags?: string[]
  mentions?: string[]
}
export interface Comment extends NewComment {
  id: number
  lastViewedAt?: Date
  createdBy?: User
  createdAt: Date
  updatedBy?: User
  updatedAt: Date
}

export type NewQuoteComment = NewComment;
export type QuoteComment = Comment;

export type NewTruckComment = NewComment;
export type TruckComment = Comment;

export enum MotorFamily {
  ICE = "ice",
  BEV = "bev",
}

export interface AssemblyHistory {
  id: number,
  assemblyChange: AssemblyChange,
  reason: string,
  createdBy: string
  createdAt: string
  initial: boolean
  changeType: string
}

export interface AssemblyChange {
  label: AssemblyDiffItem,
  notes: AssemblyDiffItem,
  standardMaterialCost: AssemblyDiffItem,
  nonOption: AssemblyDiffItem,
  obsoleted: AssemblyDiffItem,
  userRequireInput: AssemblyDiffItem,
  replacementAssembly: AssemblyDiffItem,
  metadata: MetadataChangeHistory,
  category: AssemblyDiffItem,
}

export interface MetadataChangeHistory {
  addedMetadata: AssemblyMetadata[],
  existingMetadata: AssemblyMetadata[],
  updatedMetadata: AssemblyMetadata[],
}

export interface AssemblyDiffItem {
  before: string | number | boolean,
  after: string | number | boolean,
  item: string,
}

export enum AssemblyChangeType {
  CREATE_ASSEMBLY = "createAssembly",
  IMPORT_ASSEMBLY = "importAssemblyV2",
  UPLOAD_ASSEMBLY_IMAGE = "uploadAssemblyImage",
  UPDATE_ASSEMBLY = "updateAssembly",
}

export enum EntityType {
  GOVERNMENT = "GOVERNMENT",
  PRIVATE = "PRIVATE",
  EDUCATION = "EDUCATION",
  OTHER = "OTHER",
}

export enum TruckDateFilterType {
  PRODUCTION = "PRODUCTION",
  SHIPPING = "SHIPPING",
  READY_TO_SHIP = "READY_TO_SHIP",
}

export interface TruckFilter {
  search?: string;
  entityTypeList?: string[];
  dateFilterType?: TruckDateFilterType;
  dateFilterStart?: Dayjs;
  dateFilterEnd?: Dayjs;
  dealerLst?: string[] | undefined
  salespersons?: string[] | undefined;
  endCustomerId?: number[];
  isMasterSchedule?: boolean;
  isPilotInspection?: boolean;
  isShipped?: boolean;
  sortFields?: string
  sortDirections?: string
  sortColumnValues?: string
  filterFields?: string
  filterValueNumbers?: string
  filterValues?: string
  filterValueColumns?: string
}

export interface QuoteShare {
  id: number
  user: User
  writePermission: boolean
}

export interface NotificationType {
  id?: number
  message: string
  type: string
  startDaysToProduction: number
  endDaysToProduction: number
  active?: boolean
  createdBy?: string
  createdAt?: Date
  updatedBy?: String
  updatedAt?: Date
}

export interface EngineeringTeamInfo {
  id: number
  name: string
}

export interface EngineeringTeam extends EngineeringTeamInfo {
  members?: User[]
  categories?: CategoryInfo[]
}


export interface CustomWorkTeam {
  primaryEngineer?: User,
  engineers?: User[],
  engineeringTeam?: EngineeringTeamInfo
}

export interface CustomWorkReview {
  quote: BaseQuote,
  categoryInfo: CategoryInfo,
  customWorkTeam?:CustomWorkTeam
  categoryWorkTeam?:CustomWorkTeam
  dueDate: Date
  activity?: string
  notes?: string
  ecn?: string
}

export interface TableFilter {
  id?: number;
  tableName?: string
  queryName?: string
  query?: string
}

export interface OptionFilter {
  id?: number;
  moduleName?: string
  optionName?: string
  selectionCategories?: number[];
  includeSelectionSummary?: boolean;
  rowPerUnit?: boolean;
}

export interface UserPreference {
  tableFilters: TableFilter[]
}

export interface BtsReport {
  id: number
  quoteId: string
  dealer?: Dealer
  dealerCustomer?: Customer
  endCustomer?: Customer
  truckDescription: string
  modelYear: string
  chassis: string
  bodyModel: string
  bodyMfg: string
  fuelType: string
  quantity: number
  trucks: Truck[]
  firstTruckProductionDate?: Date
  firstTruckShipDate?: Date
  nextTruckProductionDate?: Date
  nextTruckShipDate?: Date
  status: BTS_REPORT_STATUS
}

export interface FgiTransporter {
  id: number
  key: string
  name: string
}

export interface LogisticsReport {
  quoteId: string
  truckId: number
  truckSn: string
  partNo: string
  chassisModel: string
  motorFamily: MotorFamily
  productionLine: string
  readyToShip: Date
  fgiStatus: FgiStatus
  endCustomer?: Customer,
  shippingDestination?: ShippingDestination,
  shipDate?: Date
  transporter?: FgiTransporter
  stuckReason?: string
  notes?: string
  oefCost?: number
  trueCost?: number
}

export interface RepresentativeSalesSupport {
  id?: number
  salesRep: User
  salesSupport: User
}

export interface RepresentativeSalesSupportRequest {
  id?: number
  salesRepId: string
  salesSupportId: string
}

export interface QuoteAuditInfo {
  id: number
  timestamp: Date
  user?: User
  auditType: string
  quoteInfo?: QuoteInfo
}
export interface QuoteAuditData {
  auditId: number
  prevAuditId: number
  quote: Quote
}

export interface SalesTeam {
  id: number
  name?: string
  engineers?: User[]
  sales?: User[]
  support?: User[]
  viewers?: User[]
}
export interface UserSalesTeam {
  user: User
  salesTeam?: SalesTeam | undefined
}

export const userDto = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  dealerName: z.string().optional(),
  dealerId: z.string().optional(),
  phoneNumber: z.string().optional(),
});
export const modelDto = z.object({
  name: z.string(),
});
export type ModelDto = z.infer<typeof modelDto>;

export const customerDto = z.object({
  id: z.number(),
  name: z.optional(z.nullable(z.string())),
  addressLine1: z.optional(z.nullable(z.string())),
  addressLine2: z.optional(z.nullable(z.string())),
  city: z.optional(z.nullable(z.string())),
  stateProvince: z.optional(z.nullable(z.string())),
  postalCode: z.optional(z.nullable(z.string())),
  countryCode: z.optional(z.nullable(z.string())),
  enteredByUser: z.optional(z.nullable(z.string())),
  contactName: z.optional(z.nullable(z.string())),
  contactTitle: z.optional(z.nullable(z.string())),
  contactRole: z.optional(z.nullable(z.string())),
  contactPhone: z.optional(z.nullable(z.string())),
  contactEmail: z.optional(z.nullable(z.string())),
  dealerId: z.optional(z.nullable(z.string())),
  entityType: z.optional(z.nullable(z.string())),
});
export type CustomerDto = z.infer<typeof customerDto>;

export const customerWarrantyDto = z.object({
  id: z.optional(z.number()),
  name: z.string(),
  iceWarrantyFixed: z.optional(z.nullable(z.number())),
  iceWarrantyPercentage: z.optional(z.nullable(z.number())),
  bevWarrantyFixed: z.optional(z.nullable(z.number())),
  bevWarrantyPercentage: z.optional(z.nullable(z.number())),
  customers: z.optional(z.array(customerDto)),
  customerIds: z.optional(z.array(z.number())),
  createdAt: z.optional(z.string()),
  createdBy: z.optional(z.string()),
  updatedAt: z.optional(z.string()),
  updatedBy: z.optional(z.string()),
});
export type CustomerWarrantyDto = z.infer<typeof customerWarrantyDto>;

export const shippingDestinationDto = z.object({
  id: z.number(),
  name: z.string(),
  miles: z.number(),
  centsPerMile: z.number(),
  customer: z.optional(z.nullable(customerDto)),
});
export type ShippingDestinationDto = z.infer<typeof shippingDestinationDto>;

export const truckTag = z.string();

export const truckDto = z.object({
  id: z.number(),
  truckSerialNumberStr: z.string(),
  vin: z.optional(z.nullable(z.string())),
  productionDate: z.optional(z.nullable(z.string())),
  shipDate: z.optional(z.nullable(z.string())),
  readyToShip: z.optional(z.nullable(z.string())),
  projectedProductionDate: z.optional(z.nullable(z.string())),
  projectedShipDate: z.optional(z.nullable(z.string())),
  projectedReadyToShip: z.optional(z.nullable(z.string())),
  //pilotInspection: z.boolean(),
  epicorReadyToShip: z.optional(z.nullable(z.string())),
  epicorProductionDate: z.optional(z.nullable(z.string())),
  scheduledShipDate: z.optional(z.nullable(z.string())),
  pilotInspectionDate: z.optional(z.nullable(z.string())),
  epicorProductionStatus: z.optional(z.nullable(z.string())),
  truckCustomerShippingDate: z.optional(z.nullable(z.string())),
  productionLine: z.string().nullish(),
  engineSerialNumber: z.string().nullish(),
  transmissionSerialNumber: z.string().nullish(),
  tags: z.array(truckTag)
});
export type TruckDto = z.infer<typeof truckDto>;

export const documentDto = z.object({
  id: z.number(),
  assetUri : z.string(),
  contentType : z.string(),
  filename : z.string(),
});

export const poNumberDto = z.object({
  id: z.number(),
  amount: z.optional(z.number()),
  poNumber : z.optional(z.string()),
  documents : z.optional(z.array(documentDto)),
});
export const salesTeamDto = z.object({
  id: z.number(),
  engineers: z.optional(z.array(userDto)),
  sales: z.optional(z.array(userDto)),
  support: z.optional(z.array(userDto)),
  viewers: z.optional(z.array(userDto)),
});

export const quoteDto = z.object({
  quoteId: z.string(),
  partNumberString: z.string(),
  dealerCustomer: z.optional(z.nullable(customerDto)),
  endCustomer: z.optional(z.nullable(customerDto)),
  shippingDate: z.optional(z.nullable(z.coerce.date())),
  shippingDestination: z.optional(z.nullable(shippingDestinationDto)),
  model: modelDto,
  owner: userDto,
  poNumber: z.optional(poNumberDto),
  salesTeam: z.optional(salesTeamDto),
  customerShippingDate: z.optional(z.nullable(z.coerce.date())),
});
export type QuoteDto = z.infer<typeof quoteDto>;

export const scheduledTruck = z.object({
  truck: truckDto,
  quote: quoteDto,
  customerName: z.string().nullish(),
  description: z.optional(z.nullable(z.string())),
  fuelType: z.optional(z.nullable(z.string())),
  cabStyle: z.optional(z.nullable(z.string())),
  pilotInspectionsRequired: z.optional(z.number()),
})
export type ScheduledTruckDto = z.infer<typeof scheduledTruck>;

function createPaginatedResponse<T extends z.ZodTypeAny>(schema: T) {
  return z.object({
    number: z.number(),
    size: z.number(),
    totalElements: z.number(),
    content: z.array(schema),
  });
}

export const listMasterScheduleResponse = createPaginatedResponse(scheduledTruck);
export type ListMasterScheduleResponse = z.infer<typeof listMasterScheduleResponse>;
export interface ListMasterScheduleRequest {
  page: number,
  pageSize: number,
}

export interface UpdatePilotInspectionRequest {
  //pilotInspection: boolean | null;
  pilotInspectionDate?: Date | null;
}

export interface ParentQuoteHistoryDto {
  id: number
  quoteId: string
  rev: number
  quoteName: string
  type: string
  createdAt?: string;
  createdBy?: string;
}

export interface CommentStats {
  total: number
  unread: number
}

export interface ConcessionCriteria {
  id: number
  engineModel: string
  transmissionModel: string
  salesManagerConcession: number
  financeConcession: number
  createdBy: string
  createdAt: Date
  updatedBy: string
  updatedAt: Date
  active: boolean
}

export interface ConcessionCriteriaOption {
  engineModel: string[]
  transmissionModel: string[]
}

export interface DocusignConfiguration {
  integrationKey: string
}

export interface MasterScheduleEvent {
  id?: number
  productionLineSet?: string[]
  name?: string
  startDate?: Date
  endDate?: Date
  isDefault?: boolean
  bevTaktRate?: number;
  iceTaktRate?: number;
  createdBy?: string
  createdAt?: Date
  updatedBy?: string
  updatedAt?: Date
}

export interface ProductionLineWithEvents {
  productionLine: string
  events: MasterScheduleEvent[]
  scheduledTrucks: Map<Date, ScheduledTruck[]>
}

export interface ScheduledTruck {
  truckId: number
  serialNumber: string
  customerName: string
  productionDate: Date
  productionLine: string
  productionSlot: number | undefined
  motorFamily: MotorFamily
}

export interface ScheduleStaticticsRequest {
  startDate: Date
  endDate: Date
  productionLines: string[]
}

export interface ScheduleStatictics {
  prouctionLine?: string
  bevProduction?: PeriodProduction[]
  iceProduction?: PeriodProduction[]
}

export interface PeriodProduction {
  startDate?: Date
  endDate?: Date
  bevTaktRate?: number;
  iceTaktRate?: number;
  productionLine?: string
  scheduledTrucks?: number
  trucksInProduction?: number
  iceTotalSlots?: number
  bevTotalSlots?: number
  availableDays?: number
}

export interface DocusignPoRequestDetail {
  key: string
  requestedAt: Date
  completedAt?: Date
}

export interface ImageAsset {
  id: number
  assetUri: string
  filename: string
  contentType: string
  internal: boolean
  hidden: boolean
  url: string
  tags: string[]
  createdBy?: User
  createdAt: Date
  updatedBy?: User
  updatedAt: Date
}

export interface BacklogUpdateReview {
  quote: BaseQuote,
  before?: QuoteReview,
  after?: QuoteReview,
  error?: string,
}

export interface BatchBacklogUpdateResult {
  quote: BaseQuote,
  error: string,
}

export interface NotificationEvent {
  id: string;
  name?: string;
  templateId: string;
  disabled: boolean;
  recipients: string[]
}


export interface Condition {
  id: number;
  name: string;
  condition: string;
}

export interface ApprovalStepInfo {
  id: number;
  name: string;
  approvalType: ApprovalRequest
  approvers: string[]
  orderKey: number;
}

export interface ApprovalStep {
  id: number;
  name?: string;
  approvalType: ApprovalRequest
  approvers: string[]
  skipConditions?: Condition[]
  requiredConditions?: Condition[]
  orderKey: number;
  disabled: boolean;
  hidden: boolean;
  notificationEvents:string[]
}

export interface ApprovalGroup {
  id: number;
  approvalType: ApprovalRequest
  quoteRevisions: ApprovalQuoteInfo[]
  approvalStatus: RevisionApprovalStatus
}

export interface MasterScheduleFlags {
  serialNumber:string,
  leadTime:number,
  estProductionDate:Date,
  incomplete:boolean,
  pilotInspectionDate:Date,
  requestedShipDate:Date
  missingSalesOrder:boolean,
}




export type PatTokenMode = "FULL" | "READ_ONLY" | "CUSTOM";

export interface PersonalAccessToken {
  id: number;
  name: string;
  ownerUserId?: string;
  ownerEmail?: string;
  mode: PatTokenMode;
  scopedPermissions?: string[];
  lastFour: string;
  createdAt?: string;
  createdBy?: string;
  expiresAt?: string;
  lastUsedAt?: string;
  revokedAt?: string;
  revokedBy?: string;
  status: "active" | "expired" | "revoked";
}

export interface CreatePersonalAccessTokenRequest {
  name: string;
  mode: PatTokenMode;
  scopedPermissions?: string[];
  expiresAt: string;
}

export interface CreatePersonalAccessTokenResponse {
  token: PersonalAccessToken;
  /** Returned once, at creation. Never retrievable again. */
  secret: string;
}
